import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';

import { RuntimeMode } from '@blaze-shared/app-state-data-access';
import { regexpIsBearerToken } from '@blaze-shared/shared-util';

@Injectable({
  providedIn: 'root',
})
export class RuntimeModeResolverService {
  resolve(route: ActivatedRouteSnapshot): Observable<RuntimeMode> {
    const path = route.routeConfig?.path;

    if (path === 'app') {
      return of(RuntimeMode.Published);
    } else if (path === 'projects') {
      return of(RuntimeMode.Editor);
    } else if (path === 'preview') {
      return of(RuntimeMode.Preview);
    } else if (path === 'public' || path === 'p') {
      if (route.queryParams.token && regexpIsBearerToken(route.queryParams.token)) {
        return of(RuntimeMode.PublicSecure);
      }
      return of(RuntimeMode.Public);
    }
    throw new Error(`Invalid runtime mode for path: ${path}`);
  }
}
